import readingTypes from './readingTypes-pt-BR.json';
import cards from './cards-pt-BR.json';
const ptBRTranslations = {
    "title": "Bem-vindo {{name}}, ao react usando react-i18next totalmente seguro",
    "splashScreen": {
        "title": "Mensagens que guiam, equilíbrio que floresce",
        "mobileAccess": "Por favor, acesse através de um dispositivo móvel"
    },
    "login": {
        "title": "Entrar",
        "emailLabel": "Email",
        "passwordLabel": "Senha",
        "signInButton": "Entrar",
        "orSignInWith": "Ou entre com",
        "signInWithGoogle": "Entrar com Google",
        "signInWithApple": "Entrar com Apple",
        "signInWithFacebook": "Entrar com Facebook",
        "noAccount": "Não tem uma conta?",
        "register": "Cadastre-se",
        "forgotPassword": "Esqueceu sua senha?",
        "resetHere": "Redefina aqui",
        "errorFillFields": "Por favor, preencha todos os campos",
        "errorInvalidCredentials": "Credenciais inválidas, tente novamente.",
        "errorGoogleLogin": "Falha ao entrar com Google",
        "errorGoogleLoginGeneric": "Falha no login do Google"
    },
    "register": {
        "title": "Criar Conta",
        "firstNameLabel": "Nome",
        "lastNameLabel": "Sobrenome",
        "emailLabel": "Email",
        "passwordLabel": "Senha",
        "confirmPasswordLabel": "Confirmar Senha",
        "registerButton": "Cadastrar",
        "orRegisterWith": "Ou cadastre-se com",
        "registerWithGoogle": "Cadastrar com Google",
        "registerWithApple": "Cadastrar com Apple",
        "registerWithFacebook": "Cadastrar com Facebook",
        "hasAccount": "Já tem uma conta?",
        "signIn": "Entrar",
        "errorFillFields": "Por favor, preencha todos os campos obrigatórios",
        "errorPasswordsMatch": "As senhas não coincidem",
        "errorRegistrationFailed": "Falha no cadastro",
        "errorGoogleRegistration": "Falha ao cadastrar com Google",
        "errorGoogleRegistrationGeneric": "Falha no cadastro do Google"
    },
    "forgotPassword": {
        "title": "Redefinir Senha",
        "description": "Digite seu endereço de email e enviaremos instruções para redefinir sua senha.",
        "emailLabel": "Email",
        "resetButton": "Redefinir Senha",
        "rememberPassword": "Lembrou sua senha?",
        "signIn": "Entrar",
        "errorEnterEmail": "Por favor, digite seu endereço de email",
        "errorResetFailed": "Falha ao processar, usuário não encontrado.",
        "successResetSent": "Instruções de redefinição de senha foram enviadas para seu email"
    },
    "modeSelector": {
        "title": "Que Mistérios Te Buscam?",
        "digitalCards": "Cartas Digitais",
        "physicalCards": "Cartas Físicas",
        "comingSoon": "Em Breve",
        "questionLabel": "O que você gostaria de saber?",
        "questionPlaceholder": "Compartilhe sua pergunta com o universo... (ex: 'Busco orientação sobre...')",
        "beginReading": "Iniciar Leitura"
    },
    "cameraCapture": {
        "yourPhotos": "Suas Fotos",
        "noPhotosYet": "Nenhuma foto ainda. Comece a capturar!",
        "galleryPreview": "Visualização da Galeria"
    },
    "readingCards": {
        "readingFortune": "Interpretando suas cartas...",
        "readingCards": "Lendo suas Cartas",
        "sessionExpired": "Sessão expirada. Por favor, faça login novamente.",
        "errorReading": "Erro durante a leitura de tarot. Tente novamente.",
        "cardsShuffledMessage": "Suas cartas estão embaralhadas, se quiseres tu podes sembaralhar novamente."
    },
    "feedback": {
        "title": "Obrigado por nos enviar suas ideias, problemas ou apreciações.",
        "description": "Não podemos responder individualmente, mas passaremos para as equipes que estão trabalhando para ajudar a tornar o Plenamente melhor para todos.",
        "helpCenter": "Se você tem uma pergunta específica ou precisa de ajuda para resolver um problema, pode visitar nosso Centro de Ajuda ou entrar em contato conosco para conectar com nossa equipe de suporte.",
        "helpCenterLink": "Centro de Ajuda",
        "contactLink": "entre em contato conosco",
        "feedbackAbout": "Sobre o que é seu feedback?",
        "topicFeature": "Que tópico ou recurso?",
        "addDetails": "Adicionar detalhes",
        "submit": "Enviar",
        "thankYou": "Obrigado pelo seu feedback!",
        "errorSubmitting": "Erro ao enviar feedback. Tente novamente.",
        "categories": {
            "experiences": "Experiências",
            "technical": "Técnico",
            "other": "Outro"
        },
        "topics": {
            "experienceQuality": "Qualidade da experiência e comunicação",
            "appFunctionality": "Funcionalidade do app",
            "readingExperience": "Experiência de leitura",
            "journalFeatures": "Recursos do diário",
            "accountSettings": "Conta e configurações",
            "performanceStability": "Performance e estabilidade",
            "other": "Outro"
        }
    },
    "notifications": {
        "searchMessages": "Pesquisar Mensagens",
        "tabs": {
            "all": "Todas",
            "support": "Suporte",
            "reading": "Leitura",
            "message": "Mensagem"
        },
        "notifications": [
            {
                "title": "Sua Leitura Diária Está Pronta",
                "description": "Sua leitura de Três Cartas para hoje está disponível"
            },
            {
                "title": "Nova mensagem do seu Conselheiro de Tarot",
                "description": "Revisei sua leitura recente e tenho algumas percepções adicionais para compartilhar"
            },
            {
                "title": "Sessão de Leitura Confirmada",
                "description": "Sua sessão de leitura ao vivo com Sarah está agendada para amanhã às 14h"
            },
            {
                "title": "Previsão Semanal Completa",
                "description": "Sua previsão semanal de tarot foi gerada. Confira!"
            },
            {
                "title": "Discussão da Comunidade",
                "description": "Novas respostas no tópico 'Entendendo a Carta da Torre'"
            },
            {
                "title": "Assinatura Renovada",
                "description": "Sua assinatura premium de tarot foi renovada com sucesso"
            },
            {
                "title": "Leitura da Lua Nova Disponível",
                "description": "Leitura especial da fase lunar está pronta para sua revisão"
            },
            {
                "title": "Convite para Leitura em Grupo",
                "description": "Você foi convidado para participar de uma sessão de leitura em grupo neste fim de semana"
            },
            {
                "title": "Marco da Conta",
                "description": "Você completou 50 leituras! Desbloqueie seu emblema de conquista"
            },
            {
                "title": "Leitura Cruz Celta Completa",
                "description": "Seus resultados da leitura detalhada Cruz Celta estão prontos"
            }
        ]
    },
    "superMarkets": {
        "title": "Supermercados"
    },
    "settings": {
        "personalInformation": "Informações pessoais",
        "personalProfile": "Perfil pessoal",
        "paymentsPayouts": "Pagamentos e saques",
        "notifications": "Notificações",
        "privacySharing": "Privacidade e compartilhamento",
        "feedback": "Feedback",
        "logout": "Sair",
        "saveChanges": "Salvar Alterações",
        "profileUpdatedSuccess": "Perfil atualizado com sucesso!",
        "profileSavedSuccess": "Perfil salvo com sucesso!",
        "errorUpdatingProfile": "Erro ao atualizar perfil. Tente novamente.",
        "fixValidationErrors": "Por favor, corrija os erros de validação antes de enviar.",
        "loading": "Carregando..."
    },
    "onboarding": {
        "steps": {
            "userGoal": "Objetivo do Usuário",
            "experience": "Experiência",
            "deck": "Baralho",
            "birthData": "Dados de Nascimento",
            "frequency": "Frequência",
            "aiTone": "Tom da IA",
            "credits": "Créditos",
            "privacy": "Privacidade",
            "complete": "Completo"
        },
        "common": {
            "continue": "Continuar",
            "skipForNow": "Pular por enquanto",
            "beginReading": "Começar Leitura"
        },
        "account": {
            "title": "Crie sua conta",
            "advantages": {
                "saveReadings": "Salve suas leituras",
                "personalNotes": "Anotações pessoais",
                "syncedDevices": "Sincronizado entre dispositivos",
                "aiInsights": "Insights com IA",
                "dailyCompanion": "Companheiro de orientação diária"
            }
        },
        "userGoal": {
            "title": "Em que você gostaria de orientação?",
            "options": {
                "loveRelationships": "Amor e Relacionamentos",
                "careerFinances": "Carreira e Finanças",
                "personalGrowth": "Crescimento Pessoal",
                "healthWellbeing": "Saúde e Bem-estar",
                "curiosityExploration": "Curiosidade e Exploração"
            }
        },
        "tarotExperience": {
            "title": "Qual é sua familiaridade com o tarô?",
            "options": {
                "newToTarot": "Novo no Tarô",
                "newToTarotDescription": "Estou apenas começando",
                "someExperience": "Alguma Experiência",
                "someExperienceDescription": "Conheço o básico",
                "experiencedReader": "Leitor Experiente",
                "experiencedReaderDescription": "Bem versado em tarô"
            }
        },
        "deckPreference": {
            "title": "Escolha seu estilo de baralho preferido",
            "options": {
                "riderWaite": "Rider-Waite",
                "celestialMinimalist": "Celestial Minimalista",
                "thoth": "Thoth"
            }
        },
        "birthData": {
            "title": "Digite seus dados de nascimento",
            "description": "Isso ajuda a alinhar suas leituras com seu plano cósmico",
            "helpAlign": "Isso ajuda a alinhar suas leituras com seu plano cósmico",
            "birthDate": "Data de Nascimento",
            "birthTime": "Horário de Nascimento (se souber)",
            "birthPlace": "Local de Nascimento",
            "birthPlacePlaceholder": "Cidade, País",
            "cityCountryPlaceholder": "Cidade, País"
        },
        "readingFrequency": {
            "title": "Com que frequência você quer leituras?",
            "options": {
                "daily": "Diariamente",
                "dailyDescription": "Comece cada dia com orientação",
                "weekly": "Semanalmente",
                "weeklyDescription": "Insights mais profundos uma vez por semana",
                "occasionally": "Ocasionalmente",
                "occasionallyDescription": "Apenas quando precisar de orientação"
            }
        },
        "aiTone": {
            "title": "Como a IA deve interpretar suas leituras?",
            "description": "Você pode alterar isso a qualquer momento nas configurações",
            "changeTime": "Você pode alterar isso a qualquer momento nas configurações",
            "options": {
                "directPractical": "Direto e Prático",
                "directPracticalDescription": "Orientação clara e prática",
                "gentleIntuitive": "Gentil e Intuitivo",
                "gentleIntuitiveDescription": "Insights acolhedores e de apoio",
                "deepSymbolic": "Profundo e Simbólico",
                "deepSymbolicDescription": "Sabedoria profunda e metafórica"
            }
        },
        "creditIntro": {
            "title": "Entendendo o sistema de créditos",
            "subtitle": "Você começa com 3 créditos gratuitos",
            "description": "Cada leitura usa 1 crédito. Você pode obter mais créditos quando necessário.",
            "acknowledgment": "Eu entendo como os créditos funcionam",
            "startWithFreeCredits": "Você começa com 3 créditos gratuitos",
            "eachReadingUsesOneCredit": "Cada leitura usa 1 crédito. Você pode obter mais créditos quando necessário.",
            "understandCredits": "Eu entendo como os créditos funcionam"
        },
        "privacy": {
            "title": "Seu caminho é só seu",
            "description": "Tudo que você vê aqui é privado e sagrado. Seus dados são seguros e visíveis apenas para você.",
            "acknowledgment": "Eu entendo que minhas leituras são privadas",
            "everythingPrivate": "Tudo que você vê aqui é privado e sagrado. Seus dados são seguros e visíveis apenas para você.",
            "understandPrivateReadings": "Eu entendo que minhas leituras são privadas"
        },
        "completion": {
            "title": "Sua jornada te espera",
            "description": "Está tudo pronto! Sua experiência de tarô foi personalizada com base em suas preferências.",
            "allSet": "Está tudo pronto! Sua experiência de tarô foi personalizada com base em suas preferências.",
            "beginReading": "Começar Leitura"
        }
    },
    "cardsMeaningWidget": {
        "title": "Descubra os Significados das Cartas",
        "description": "Explore o rico simbolismo e as interpretações de todas as 78 cartas do tarô"
    },
    "customMessage": {
        "goodMorning": "Bom Dia",
        "goodAfternoon": "Boa Tarde",
        "goodEvening": "Boa Noite",
        "greeting": "{{greeting}}, {{name}}. Hoje é {{date}}. Seu dia em resumo:"
    },
    "journal": {
        "noEntriesYet": "Nenhuma entrada no diário ainda",
        "startJourney": "Comece sua jornada de diário adicionando sua primeira entrada",
        "addEntry": "Adicionar Entrada no Diário",
        "title": "Título",
        "howAreYouFeeling": "Como você está se sentindo?",
        "writeYourThoughts": "Escreva seus pensamentos...",
        "saveEntry": "Salvar Entrada",
        "update": "Atualizar",
        "save": "Salvar",
        "myDay": "Meu Dia",
        "journal": "Diário",
        "moods": {
            "happy": "Feliz",
            "calm": "Calmo",
            "anxious": "Ansioso",
            "stressed": "Estressado",
            "excited": "Empolgado",
            "neutral": "Neutro",
            "sad": "Triste",
            "angry": "Irritado"
        }
    },
    "fastReadingCategory": {
        "questionLabel": "O que você gostaria de saber?",
        "beginReading": "Iniciar Leitura",
        "noFavorites": "Ainda não há leituras favoritas. Comece as leituras para ver seus favoritos aqui!"
    },
    "cards": {
        "majorArcana": {
            "theFool": "O Louco",
            "theMagician": "O Mago",
            "theHighPriestess": "A Alta Sacerdotisa",
            "theEmpress": "A Imperatriz",
            "theEmperor": "O Imperador",
            "theHierophant": "O Hierofante",
            "theLovers": "Os Amantes",
            "theChariot": "A Carruagem",
            "strength": "A Força",
            "theHermit": "O Eremita",
            "wheelOfFortune": "A Roda da Fortuna",
            "justice": "A Justiça",
            "theHangedMan": "O Enforcado",
            "death": "A Morte",
            "temperance": "A Temperança",
            "theDevil": "O Diabo",
            "theTower": "A Torre",
            "theStar": "A Estrela",
            "theMoon": "A Lua",
            "theSun": "O Sol",
            "judgement": "O Julgamento",
            "theWorld": "O Mundo"
        },
        "cups": {
            "aceOfCups": "Ás de Copas",
            "twoOfCups": "Dois de Copas",
            "threeOfCups": "Três de Copas",
            "fourOfCups": "Quatro de Copas",
            "fiveOfCups": "Cinco de Copas",
            "sixOfCups": "Seis de Copas",
            "sevenOfCups": "Sete de Copas",
            "eightOfCups": "Oito de Copas",
            "nineOfCups": "Nove de Copas",
            "tenOfCups": "Dez de Copas",
            "pageOfCups": "Valete de Copas",
            "knightOfCups": "Cavaleiro de Copas",
            "queenOfCups": "Rainha de Copas",
            "kingOfCups": "Rei de Copas"
        },
        "pentacles": {
            "aceOfPentacles": "Ás de Ouros",
            "twoOfPentacles": "Dois de Ouros",
            "threeOfPentacles": "Três de Ouros",
            "fourOfPentacles": "Quatro de Ouros",
            "fiveOfPentacles": "Cinco de Ouros",
            "sixOfPentacles": "Seis de Ouros",
            "sevenOfPentacles": "Sete de Ouros",
            "eightOfPentacles": "Oito de Ouros",
            "nineOfPentacles": "Nove de Ouros",
            "tenOfPentacles": "Dez de Ouros",
            "pageOfPentacles": "Valete de Ouros",
            "knightOfPentacles": "Cavaleiro de Ouros",
            "queenOfPentacles": "Rainha de Ouros",
            "kingOfPentacles": "Rei de Ouros"
        },
        "swords": {
            "aceOfSwords": "Ás de Espadas",
            "twoOfSwords": "Dois de Espadas",
            "threeOfSwords": "Três de Espadas",
            "fourOfSwords": "Quatro de Espadas",
            "fiveOfSwords": "Cinco de Espadas",
            "sixOfSwords": "Seis de Espadas",
            "sevenOfSwords": "Sete de Espadas",
            "eightOfSwords": "Oito de Espadas",
            "nineOfSwords": "Nove de Espadas",
            "tenOfSwords": "Dez de Espadas",
            "pageOfSwords": "Valete de Espadas",
            "knightOfSwords": "Cavaleiro de Espadas",
            "queenOfSwords": "Rainha de Espadas",
            "kingOfSwords": "Rei de Espadas"
        },
        "wands": {
            "aceOfWands": "Ás de Paus",
            "twoOfWands": "Dois de Paus",
            "threeOfWands": "Três de Paus",
            "fourOfWands": "Quatro de Paus",
            "fiveOfWands": "Cinco de Paus",
            "sixOfWands": "Seis de Paus",
            "sevenOfWands": "Sete de Paus",
            "eightOfWands": "Oito de Paus",
            "nineOfWands": "Nove de Paus",
            "tenOfWands": "Dez de Paus",
            "pageOfWands": "Valete de Paus",
            "knightOfWands": "Cavaleiro de Paus",
            "queenOfWands": "Rainha de Paus",
            "kingOfWands": "Rei de Paus"
        },
        "lenormand": {
            "rider": "Cavaleiro",
            "clover": "Trevo",
            "ship": "Navio",
            "house": "Casa",
            "tree": "Árvore",
            "clouds": "Nuvens",
            "snake": "Serpente",
            "coffin": "Caixão",
            "bouquet": "Buquê",
            "scythe": "Foice",
            "whip": "Chicote",
            "birds": "Pássaros",
            "child": "Criança",
            "fox": "Raposa",
            "bear": "Urso",
            "stars": "Estrelas",
            "stork": "Cegonha",
            "dog": "Cão",
            "tower": "Torre",
            "garden": "Jardim",
            "mountain": "Montanha",
            "crossroads": "Encruzilhada",
            "mice": "Ratos",
            "heart": "Coração",
            "ring": "Anel",
            "book": "Livro",
            "letter": "Carta",
            "man": "Homem",
            "woman": "Mulher",
            "lily": "Lírio",
            "sun": "Sol",
            "moon": "Lua",
            "key": "Chave",
            "fish": "Peixe",
            "anchor": "Âncora",
            "cross": "Cruz"
        }
    },
    "cardDialog": {
        "primaryMeaning": "Significado Principal",
        "interpretation": "Interpretação",
        "reversed": "Invertida"
    },
    "cardCategories": {
        "majorArcana": "Arcanos Maiores",
        "cups": "Copas",
        "pentacles": "Ouros",
        "swords": "Espadas",
        "wands": "Paus"
    },
    "pages": {
        "journal": "Diário",
        "shareFeedback": "Compartilhar Feedback",
        "readingCards": "Lendo Cartas",
        "reading": "Leitura",
        "displayReading": "Exibir Leitura",
        "modeSelector": "Seletor de Modo",
        "selectReading": "Selecionar Leitura",
        "settings": "Configurações",
        "payments": "Pagamentos",
        "personalInformation": "Informações Pessoais",
        "personalProfile": "Perfil Pessoal",
        "readingList": "Lista de Leituras",
        "notifications": "Notificações",
        "cardMeanings": "Significados das Cartas",
        "chat": "Chat"
    },
    "readingPage": {
        "directAnswer": "Resposta Rápida",
        "yourQuestion": "Sua Pergunta",
        "theSpread": "O Jogo",
        "cardInteractions": "Interações das Cartas",
        "conclusion": "Conclusão",
        "practicalAdvice": "Conselhos Práticos",
        "readMore": "Ler Mais",
        "touchCardsInfo": "Toque nas cartas para mais informações",
        "noReadingsFound": "Nenhuma leitura encontrada",
        "tryNewReading": "Tente fazer uma nova leitura primeiro!",
        "loadingReading": "Carregando sua leitura...",
        "preparingYourReading": "Preparando seus insights místicos",
        "startAudioReading": "🎧 Escutar Leitura",
        "shareReading": "Compartilhar Leitura",
        "cards": "Cartas",
        "reversed": "Invertida",
        "shareMessage": "Compartilhe sua leitura de tarot com amigos e família",
        "myCardOfTheDay": "Minha carta do dia:",
        "getYours": "Tire a sua",
        "appName": "lumatarot.app",
        "saveAndShare": "Salve sua imagem e compartilhe na sua rede social preferida",
        "shareTitle": "Luma Tarot",
        "shareText": "Minha leitura de tarot do LumaTarot 🌙",
        "readCards": "Ler Cartas"
    },
    "home": {
        "dailyReading": "Leitura Diária",
        "completeReading": "Leitura Completa",
        "favoriteReadingTypes": "Tipos de Leitura Favoritos",
        "dailyReadingPrompt": "Descubra a mensagem que o universo tem para você hoje",
        "chooseCard": "Escolher sua Carta",
        "getPremium": {
            "bestValue": "Melhor Valor",
            "title": "Obter Premium",
            "description": "Leituras Personalizadas Quase Ilimitadas"
        },
        "statistics": {
            "topSuit": "Naipe Principal",
            "topNumberOrRank": "Número ou Carta Principal",
            "last7Days": "Últimos 7 Dias"
        }
    },
    "credits": {
        "availableCredits": "Créditos Disponíveis",
        "buyCredits": "Comprar Créditos",
        "creditsDescription": "Créditos são usados para gerar leituras e acessar recursos premium.",
        "betaTestTitle": "Créditos de Teste Beta",
        "betaTestDescription": "Você receberá 200 créditos gratuitos para explorar todas as funcionalidades durante nosso teste beta. Esses créditos permitirão que você experimente todo o potencial de nossas leituras de tarot!",
        "recentActivity": "Atividade Recente",
        "noRecentActivity": "Nenhuma atividade recente",
        "creditsUpdatedSuccess": "Créditos atualizados com sucesso!",
        "loading": "Carregando..."
    },
    "personalInfo": {
        "title": "Informações Pessoais",
        "description": "Atualize suas informações pessoais. Quanto mais você compartilhar, mais podemos ajudá-lo.",
        "firstName": "Nome",
        "lastName": "Sobrenome",
        "username": "Nome de usuário",
        "email": "E-mail",
        "password": "Senha",
        "dateOfBirth": "Data de Nascimento",
        "preferredLanguage": "Idioma Preferido",
        "selectPreferredLanguage": "Selecionar Idioma Preferido",
        "gender": "Gênero",
        "selectGender": "Selecionar gênero",
        "male": "Masculino",
        "female": "Feminino",
        "other": "Outro",
        "preferNotToSay": "Prefiro não dizer",
        "birthdate": "Data de Nascimento",
        "changePassword": "Alterar Senha",
        "currentPassword": "Senha Atual",
        "newPassword": "Nova Senha",
        "confirmPassword": "Confirmar Senha",
        "address": "Endereço",
        "street": "Rua",
        "number": "Número",
        "complement": "Complemento",
        "zipCode": "CEP",
        "city": "Cidade",
        "state": "Estado",
        "country": "País",
        "selectCountry": "Selecionar país",
        "unitedStates": "Estados Unidos",
        "canada": "Canadá",
        "france": "França",
        "germany": "Alemanha",
        "validation": {
            "firstnameRequired": "Nome é obrigatório",
            "lastnameRequired": "Sobrenome é obrigatório",
            "emailRequired": "E-mail é obrigatório",
            "emailInvalid": "Por favor insira um endereço de e-mail válido",
            "birthdateRequired": "Data de nascimento é obrigatória",
            "currentPasswordRequired": "Senha atual é obrigatória para alterar a senha",
            "passwordMinLength": "A senha deve ter pelo menos 8 caracteres",
            "passwordUppercase": "A senha deve conter pelo menos uma letra maiúscula",
            "passwordLowercase": "A senha deve conter pelo menos uma letra minúscula",
            "passwordNumber": "A senha deve conter pelo menos um número",
            "passwordsDoNotMatch": "As senhas não coincidem",
            "pleaseFixError": "Por favor corrija o erro no formulário antes de enviar",
            "pleaseFixErrors": "Por favor corrija os erros no formulário antes de enviar",
            "errors": "erros",
            "streetNumberRequired": "Número da rua é obrigatório quando a rua é fornecida",
            "invalidZipCode": "Formato de CEP inválido"
        },
        "passwordHelper": "Deixe em branco para manter a senha atual",
        "messages": {
            "profileSavedSuccess": "Perfil salvo com sucesso!",
            "failedToUpdateProfile": "Falha ao atualizar perfil. Tente novamente.",
            "noAuthToken": "Token de autenticação não encontrado"
        }
    },
    "personalProfile": {
        "title": "Perfil Pessoal",
        "experienceLevel": "Nível de Experiência",
        "selectExperienceLevel": "Selecionar Nível de Experiência",
        "preferredReadingStyle": "Estilo de Leitura Preferido",
        "selectPreferredReadingStyle": "Selecionar Estilo de Leitura Preferido",
        "useReversedCards": "Usar Cartas Invertidas",
        "primaryLifeFocus": "Foco Principal da Vida",
        "selectPrimaryLifeFocus": "Selecionar Foco Principal da Vida",
        "intentions": "Intenções",
        "selectIntentions": "Selecionar Intenções",
        "language": "Idioma",
        "selectLanguage": "Selecionar Idioma"
    },
    "billing": {
        "title": "Leia suas cartas a qualquer momento e obtenha respostas personalizadas.",
        "credits": "Créditos",
        "betterValue": "MELHOR VALOR",
        "bestValue": "MELHOR VALOR",
        "creditsNeverExpire": "Créditos nunca expiram e são resgatados apenas para perguntas que podem ser respondidas com tarot.",
        "buyQuestions": "COMPRAR {{count}} PERGUNTAS",
        "processingPurchase": "Processando sua compra, isso pode levar um momento...",
        "purchaseSuccessPolling": "Compra realizada com sucesso! Seus créditos serão atualizados em alguns instantes.",
        "purchaseDelayed": "Compra realizada com sucesso! Os créditos serão atualizados em breve.",
        "purchaseFailed": "Falha na compra: {{error}}"
    },
    "payment": {
        "emailLabel": "Email",
        "emailPlaceholder": "Digite seu email",
        "cardDetailsLabel": "Dados do cartão",
        "processing": "Processando...",
        "buyNow": "Comprar Agora",
        "errorInvalidPriceId": "Erro: ID de preço inválido",
        "errorCardElementNotFound": "Elemento de cartão não encontrado.",
        "errorAuthTokenNotFound": "Token de autenticação não encontrado",
        "successPayment": "Pagamento realizado com sucesso! Você receberá um email de confirmação em breve.",
        "errorInvalidPriceIdDetail": "ID de preço inválido: {{priceId}}",
        "errorUnknown": "Ocorreu um erro desconhecido",
        "errorPrefix": "Erro: "
    },
    "cardTranslations": {
        "majorArcana": {
            "0": {
                "card_name": "O Louco",
                "primary_meaning": "Novos começos, inocência, espontaneidade",
                "interpretation": "O Louco representa novos começos, inocência e espontaneidade. Sugere dar um salto de fé e embarcar em novas aventuras sem medo. Esta carta encoraja abraçar oportunidades com mente aberta e confiar na jornada à frente, mesmo quando o caminho não está claro."
            },
            "1": {
                "card_name": "O Mago",
                "primary_meaning": "Manifestação, recursos, poder",
                "interpretation": "O Mago simboliza manifestação, poder pessoal e utilização das próprias habilidades. Representa ter todas as ferramentas necessárias para ter sucesso e a capacidade de canalizar a vontade em realidade. Esta carta sugere agir com confiança e usar seus talentos para alcançar seus objetivos."
            },
            "2": {
                "card_name": "A Alta Sacerdotisa",
                "primary_meaning": "Intuição, mistério, conhecimento interior",
                "interpretation": "A Alta Sacerdotisa representa intuição, mistério e a mente subconsciente. Ela simboliza conhecimento oculto, sabedoria interior e habilidades psíquicas. Esta carta sugere ouvir sua voz interior e prestar atenção aos seus sonhos e insights intuitivos."
            },
            "3": {
                "card_name": "A Imperatriz",
                "primary_meaning": "Abundância, nutrição, fertilidade",
                "interpretation": "A Imperatriz simboliza abundância, nutrição e criatividade. Ela representa fertilidade, crescimento e os aspectos nutridores da vida. Esta carta sugere um tempo de criação, seja artística, pessoal ou profissional, e encoraja abraçar sua natureza nutridora."
            },
            "4": {
                "card_name": "O Imperador",
                "primary_meaning": "Autoridade, estrutura, liderança",
                "interpretation": "O Imperador representa autoridade, estrutura e liderança. Ele simboliza poder, estabilidade e o estabelecimento da ordem. Esta carta sugere tomar controle de situações, estabelecer limites e implementar sistemas para o sucesso."
            },
            "5": {
                "card_name": "O Hierofante",
                "primary_meaning": "Tradição, espiritualidade, orientação",
                "interpretation": "O Hierofante simboliza tradição, abordagens convencionais e orientação espiritual. Ele representa instituições estabelecidas, aprender com professores e seguir caminhos tradicionais. Esta carta sugere buscar sabedoria de fontes estabelecidas e respeitar métodos convencionais."
            },
            "6": {
                "card_name": "Os Amantes",
                "primary_meaning": "Escolha, relacionamentos, harmonia",
                "interpretation": "Os Amantes representam escolhas, relacionamentos e harmonia. Esta carta simboliza decisões importantes, particularmente em assuntos do coração. Sugere examinar seus valores e fazer escolhas alinhadas com seu maior bem, enquanto também indica parcerias significativas."
            },
            "7": {
                "card_name": "A Carruagem",
                "primary_meaning": "Determinação, força de vontade, sucesso",
                "interpretation": "A Carruagem representa determinação, força de vontade e vitória através do esforço. Simboliza superar obstáculos através da confiança e controle. Esta carta sugere seguir em frente com propósito e manter o foco para alcançar seus objetivos."
            },
            "8": {
                "card_name": "A Força",
                "primary_meaning": "Força interior, paciência, compaixão",
                "interpretation": "A Força representa poder interior, paciência e controle gentil. Simboliza dominar a própria natureza interior e mostrar coragem através da compaixão. Esta carta sugere lidar com situações desafiadoras com graça e fortaleza interior ao invés de força."
            },
            "9": {
                "card_name": "O Eremita",
                "primary_meaning": "Introspecção, solidão, orientação",
                "interpretation": "O Eremita representa introspecção, orientação interior e busca espiritual. Simboliza tomar tempo para auto-reflexão e buscar sabedoria interior. Esta carta sugere um período de retiro para encontrar compreensão mais profunda e verdade pessoal."
            },
            "10": {
                "card_name": "A Roda da Fortuna",
                "primary_meaning": "Mudança, ciclos, destino",
                "interpretation": "A Roda da Fortuna representa mudança, ciclos e destino. Simboliza os altos e baixos da vida e as forças maiores em ação. Esta carta sugere que mudanças significativas estão chegando e nos lembra que tanto os bons quanto os maus tempos são temporários."
            },
            "11": {
                "card_name": "A Justiça",
                "primary_meaning": "Equilíbrio, verdade, causa e efeito",
                "interpretation": "A Justiça representa justiça, verdade e causa e efeito. Simboliza karma, assuntos legais e a necessidade de equilíbrio. Esta carta sugere que decisões e resultados serão justos e que a verdade prevalecerá."
            },
            "12": {
                "card_name": "O Enforcado",
                "primary_meaning": "Rendição, nova perspectiva, sacrifício",
                "interpretation": "O Enforcado representa rendição, novas perspectivas e sacrifício voluntário. Simboliza deixar ir e ver as coisas de forma diferente. Esta carta sugere que pausar e ver as coisas de um novo ângulo trará insights valiosos."
            },
            "13": {
                "card_name": "A Morte",
                "primary_meaning": "Transformação, finais, renovação",
                "interpretation": "A Morte representa transformação, finais e renovação. Simboliza grandes mudanças de vida e o fim de uma fase levando ao início de outra. Esta carta sugere que embora os finais possam ser difíceis, eles abrem caminho para novos começos necessários."
            },
            "14": {
                "card_name": "A Temperança",
                "primary_meaning": "Equilíbrio, moderação, paciência",
                "interpretation": "A Temperança representa equilíbrio, moderação e harmonia. Simboliza encontrar o meio termo e combinar diferentes elementos com sucesso. Esta carta sugere encontrar equilíbrio em todas as coisas e praticar paciência para alcançar seus objetivos."
            },
            "15": {
                "card_name": "O Diabo",
                "primary_meaning": "Escravidão, materialismo, sombra",
                "interpretation": "O Diabo representa escravidão, materialismo e nossos aspectos sombra. Simboliza estar preso por preocupações materiais ou padrões não saudáveis. Esta carta sugere examinar o que te prende e reconhecer que você tem o poder de se libertar."
            },
            "16": {
                "card_name": "A Torre",
                "primary_meaning": "Mudança súbita, agitação, revelação",
                "interpretation": "A Torre representa mudança súbita, agitação e descoberta. Simboliza o colapso de estruturas falsas e revelações súbitas. Esta carta sugere que embora a mudança possa ser dramática, ela cria espaço para algo melhor ser construído."
            },
            "17": {
                "card_name": "A Estrela",
                "primary_meaning": "Esperança, inspiração, serenidade",
                "interpretation": "A Estrela representa esperança, inspiração e conexão espiritual. Simboliza renovação da fé e encontrar orientação em tempos escuros. Esta carta sugere manter a esperança e confiar que você está sendo guiado para seu maior bem."
            },
            "18": {
                "card_name": "A Lua",
                "primary_meaning": "Ilusão, intuição, subconsciente",
                "interpretation": "A Lua representa ilusão, intuição e a mente subconsciente. Simboliza sonhos, medos e coisas escondidas na sombra. Esta carta sugere prestar atenção aos seus sonhos e intuição enquanto estar ciente de que as coisas podem não ser como parecem."
            },
            "19": {
                "card_name": "O Sol",
                "primary_meaning": "Alegria, sucesso, vitalidade",
                "interpretation": "O Sol representa alegria, sucesso e energia positiva. Simboliza clareza, felicidade e realização. Esta carta sugere um tempo de realização e bem-estar, trazendo luz para todas as áreas da vida."
            },
            "20": {
                "card_name": "O Julgamento",
                "primary_meaning": "Renascimento, chamado interior, absolvição",
                "interpretation": "O Julgamento representa renascimento, chamado interior e redenção. Simboliza responder a um chamado superior e fazer decisões que mudam a vida. Esta carta sugere ouvir e responder ao seu verdadeiro chamado e abraçar a transformação pessoal."
            },
            "21": {
                "card_name": "O Mundo",
                "primary_meaning": "Conclusão, integração, realização",
                "interpretation": "O Mundo representa conclusão, totalidade e realização. Simboliza a conclusão bem-sucedida de um ciclo e integração das lições de vida. Esta carta sugere alcançar objetivos e sentir um senso de totalidade e conclusão."
            }
        },
        "cups": {
            "22": {
                "card_name": "Ás de Copas",
                "primary_meaning": "Novos sentimentos, intuição, relacionamentos",
                "interpretation": "O Ás de Copas representa novos começos emocionais, mensagens intuitivas e o início de relacionamentos. Sugere o fluxo de novos sentimentos e conexões espirituais."
            },
            "23": {
                "card_name": "Dois de Copas",
                "primary_meaning": "Parceria, atração, conexão",
                "interpretation": "O Dois de Copas representa parcerias, atração mútua e conexões profundas. Sugere a união de duas entidades em harmonia e compreensão."
            },
            "24": {
                "card_name": "Três de Copas",
                "primary_meaning": "Celebração, amizade, comunidade",
                "interpretation": "O Três de Copas representa celebração, amizade e alegria comunitária. Sugere se reunir com outros para compartilhar felicidade e sucesso."
            },
            "25": {
                "card_name": "Quatro de Copas",
                "primary_meaning": "Contemplação, apatia, reavaliação",
                "interpretation": "O Quatro de Copas representa contemplação, apatia e reavaliação de situações emocionais. Sugere um tempo de introspecção e possivelmente perder oportunidades devido ao auto-absorção."
            },
            "26": {
                "card_name": "Cinco de Copas",
                "primary_meaning": "Perda, decepção, arrependimento",
                "interpretation": "O Cinco de Copas representa perda, decepção e arrependimento emocional. Sugere focar demais no que foi perdido enquanto negligencia o que permanece."
            },
            "27": {
                "card_name": "Seis de Copas",
                "primary_meaning": "Nostalgia, infância, inocência",
                "interpretation": "O Seis de Copas representa nostalgia, memórias da infância e prazer inocente. Sugere revisitar o passado e encontrar alegria em prazeres simples."
            },
            "28": {
                "card_name": "Sete de Copas",
                "primary_meaning": "Escolhas, fantasia, ilusão",
                "interpretation": "O Sete de Copas representa escolhas, fantasia e ilusão. Sugere múltiplas opções que podem não ser todas realistas, requerendo discriminação cuidadosa."
            },
            "29": {
                "card_name": "Oito de Copas",
                "primary_meaning": "Retirada, busca por significado, seguir em frente",
                "interpretation": "O Oito de Copas representa retirada emocional, busca por significado mais profundo e seguir em frente. Sugere deixar para trás o que é familiar em busca de algo mais gratificante."
            },
            "30": {
                "card_name": "Nove de Copas",
                "primary_meaning": "Satisfação, desejos realizados, contentamento",
                "interpretation": "O Nove de Copas representa satisfação emocional, desejos realizados e contentamento. Sugere alcançar bem-estar emocional e conseguir o que você desejou."
            },
            "31": {
                "card_name": "Dez de Copas",
                "primary_meaning": "Harmonia, família, felicidade duradoura",
                "interpretation": "O Dez de Copas representa harmonia, felicidade familiar e felicidade duradoura. Sugere alcançar realização emocional e compartilhar alegria com entes queridos."
            },
            "32": {
                "card_name": "Valete de Copas",
                "primary_meaning": "Novos sentimentos, mensagens intuitivas, criatividade",
                "interpretation": "O Valete de Copas representa novos sentimentos, mensagens intuitivas e começos criativos. Sugere abertura emocional e receber insights intuitivos."
            },
            "33": {
                "card_name": "Cavaleiro de Copas",
                "primary_meaning": "Romance, charme, imaginação",
                "interpretation": "O Cavaleiro de Copas representa romance, charme e perseguir buscas emocionais. Sugere seguir seu coração e trazer visões criativas para a realidade."
            },
            "34": {
                "card_name": "Rainha de Copas",
                "primary_meaning": "Empatia, intuição, apoio emocional",
                "interpretation": "A Rainha de Copas representa empatia, intuição e nutrição emocional. Ela sugere compreensão emocional profunda e a capacidade de aconselhar outros."
            },
            "35": {
                "card_name": "Rei de Copas",
                "primary_meaning": "Equilíbrio emocional, diplomacia, sabedoria",
                "interpretation": "O Rei de Copas representa equilíbrio emocional, diplomacia e conselho sábio. Sugere domínio sobre as emoções e a capacidade de permanecer calmo em situações difíceis."
            }
        },
        "pentacles": {
            "36": {
                "card_name": "Ás de Ouros",
                "primary_meaning": "Novos recursos, prosperidade, potencial",
                "interpretation": "O Ás de Ouros representa novas oportunidades materiais, prosperidade e potencial para abundância. Sugere a semente de novas aventuras financeiras ou materiais."
            },
            "37": {
                "card_name": "Dois de Ouros",
                "primary_meaning": "Equilíbrio, adaptabilidade, gestão do tempo",
                "interpretation": "O Dois de Ouros representa equilíbrio, adaptabilidade e malabarismo com prioridades. Sugere a necessidade de manter flexibilidade enquanto lida com múltiplas responsabilidades."
            },
            "38": {
                "card_name": "Três de Ouros",
                "primary_meaning": "Trabalho em equipe, artesanato, habilidade",
                "interpretation": "O Três de Ouros representa trabalho em equipe, artesanato e cooperação habilidosa. Sugere trabalhar bem com outros para criar algo de qualidade."
            },
            "39": {
                "card_name": "Quatro de Ouros",
                "primary_meaning": "Segurança, conservação, frugalidade",
                "interpretation": "O Quatro de Ouros representa segurança, conservação e segurar recursos. Sugere ser cuidadoso com recursos mas possivelmente ser muito conservador."
            },
            "40": {
                "card_name": "Cinco de Ouros",
                "primary_meaning": "Dificuldade, pobreza, insegurança",
                "interpretation": "O Cinco de Ouros representa dificuldade material, pobreza e sentir-se deixado no frio. Sugere dificuldades temporárias mas também recursos negligenciados."
            },
            "41": {
                "card_name": "Seis de Ouros",
                "primary_meaning": "Generosidade, caridade, compartilhar riqueza",
                "interpretation": "O Seis de Ouros representa generosidade, caridade e compartilhar riqueza. Sugere dar ou receber ajuda e manter equilíbrio em trocas."
            },
            "42": {
                "card_name": "Sete de Ouros",
                "primary_meaning": "Avaliação, paciência, investimento",
                "interpretation": "O Sete de Ouros representa avaliação, paciência e investimento de longo prazo. Sugere avaliar progresso e considerar se continuar esforços atuais."
            },
            "43": {
                "card_name": "Oito de Ouros",
                "primary_meaning": "Desenvolvimento de habilidades, diligência, detalhe",
                "interpretation": "O Oito de Ouros representa desenvolvimento de habilidades, diligência e atenção aos detalhes. Sugere dedicar-se a dominar um ofício ou habilidade."
            },
            "44": {
                "card_name": "Nove de Ouros",
                "primary_meaning": "Independência, luxo, autoconfiança",
                "interpretation": "O Nove de Ouros representa independência, luxo e autoconfiança. Sugere alcançar conforto material através de disciplina e autocontrole."
            },
            "45": {
                "card_name": "Dez de Ouros",
                "primary_meaning": "Riqueza, herança, estabelecimento",
                "interpretation": "O Dez de Ouros representa riqueza, herança e sucesso estabelecido. Sugere alcançar segurança material duradoura e criar um legado."
            },
            "46": {
                "card_name": "Valete de Ouros",
                "primary_meaning": "Novos recursos, estudo, manifestação",
                "interpretation": "O Valete de Ouros representa novas oportunidades materiais, estudo e manifestação. Sugere aprendizado prático e o início de aventuras materiais."
            },
            "47": {
                "card_name": "Cavaleiro de Ouros",
                "primary_meaning": "Trabalho duro, rotina, responsabilidade",
                "interpretation": "O Cavaleiro de Ouros representa trabalho duro, rotina e responsabilidade. Sugere progresso constante através de esforço metódico e atenção aos detalhes."
            },
            "48": {
                "card_name": "Rainha de Ouros",
                "primary_meaning": "Nutrição, abundância, segurança",
                "interpretation": "A Rainha de Ouros representa nutrição abundante, sabedoria prática e segurança material. Ela sugere criar conforto e segurança através de meios práticos."
            },
            "49": {
                "card_name": "Rei de Ouros",
                "primary_meaning": "Abundância, poder, segurança",
                "interpretation": "O Rei de Ouros representa abundância material, perspicácia nos negócios e segurança financeira. Sugere domínio sobre o reino material e administração sábia de recursos."
            }
        },
        "swords": {
            "50": {
                "card_name": "Ás de Espadas",
                "primary_meaning": "Clareza mental, novas ideias, verdade",
                "interpretation": "O Ás de Espadas representa clareza mental, novas ideias e momentos de descoberta. Sugere cortar através da confusão para encontrar verdade e compreensão."
            },
            "51": {
                "card_name": "Dois de Espadas",
                "primary_meaning": "Decisão, impasse, conflito interior",
                "interpretation": "O Dois de Espadas representa decisões difíceis, situações de impasse e conflito interior. Sugere a necessidade de enfrentar escolhas que requerem equilíbrio cuidadoso e consideração."
            },
            "52": {
                "card_name": "Três de Espadas",
                "primary_meaning": "Desgosto, luto, rejeição",
                "interpretation": "O Três de Espadas representa desgosto, luto e verdades dolorosas. Sugere experimentar dor emocional mas também o potencial de cura através da aceitação."
            },
            "53": {
                "card_name": "Quatro de Espadas",
                "primary_meaning": "Descanso, recuperação, contemplação",
                "interpretation": "O Quatro de Espadas representa descanso, recuperação e contemplação silenciosa. Sugere tomar tempo para recuperar e restaurar energia mental."
            },
            "54": {
                "card_name": "Cinco de Espadas",
                "primary_meaning": "Conflito, derrota, vencer a qualquer custo",
                "interpretation": "O Cinco de Espadas representa conflito, derrota e vitórias pírricas. Sugere que vencer ao custo de relacionamentos ou reputação pode não valer a pena."
            },
            "55": {
                "card_name": "Seis de Espadas",
                "primary_meaning": "Transição, seguir em frente, cura",
                "interpretation": "O Seis de Espadas representa transição, seguir em frente e cura gradual. Sugere deixar dificuldades para trás e mover-se em direção a águas mais calmas."
            },
            "56": {
                "card_name": "Sete de Espadas",
                "primary_meaning": "Engano, estratégia, astúcia",
                "interpretation": "O Sete de Espadas representa engano, estratégia e planejamento cuidadoso. Sugere ser estratégico ou observar desonestidade em outros."
            },
            "57": {
                "card_name": "Oito de Espadas",
                "primary_meaning": "Restrição, aprisionamento, mentalidade de vítima",
                "interpretation": "O Oito de Espadas representa sentir-se restrito, preso e limitado por circunstâncias. Sugere que limitações podem ser mais mentais do que reais."
            },
            "58": {
                "card_name": "Nove de Espadas",
                "primary_meaning": "Ansiedade, preocupação, medo",
                "interpretation": "O Nove de Espadas representa ansiedade, preocupação e pesadelos. Sugere angústia mental e a necessidade de enfrentar medos ao invés de deixá-los crescer."
            },
            "59": {
                "card_name": "Dez de Espadas",
                "primary_meaning": "Finais, fundo do poço, novo amanhecer",
                "interpretation": "O Dez de Espadas representa finais dolorosos, fundo do poço e potencial para novos começos. Sugere que embora uma situação tenha terminado mal, renovação é possível."
            },
            "60": {
                "card_name": "Valete de Espadas",
                "primary_meaning": "Novas ideias, curiosidade, comunicação",
                "interpretation": "O Valete de Espadas representa novas ideias, curiosidade e comunicação. Sugere curiosidade intelectual e o desejo de aprender e compreender."
            },
            "61": {
                "card_name": "Cavaleiro de Espadas",
                "primary_meaning": "Ação, ambição, direção",
                "interpretation": "O Cavaleiro de Espadas representa ação rápida, ambição e comunicação direta. Sugere avançar com ideias e planos, às vezes muito apressadamente."
            },
            "62": {
                "card_name": "Rainha de Espadas",
                "primary_meaning": "Pensamento claro, independência, comunicação direta",
                "interpretation": "A Rainha de Espadas representa pensamento claro, independência e comunicação direta. Ela sugere a capacidade de ver a verdade e comunicá-la sem viés emocional."
            },
            "63": {
                "card_name": "Rei de Espadas",
                "primary_meaning": "Clareza mental, autoridade, verdade",
                "interpretation": "O Rei de Espadas representa clareza mental, autoridade intelectual e liderança ética. Sugere tomar decisões baseadas em lógica e princípios éticos."
            }
        },
        "wands": {
            "64": {
                "card_name": "Ás de Paus",
                "primary_meaning": "Novas oportunidades, inspiração, potencial",
                "interpretation": "O Ás de Paus representa novos começos, inspiração e potencial criativo. Sugere a faísca de uma nova ideia ou aventura com grande potencial para crescimento e sucesso."
            },
            "65": {
                "card_name": "Dois de Paus",
                "primary_meaning": "Planejamento, decisões, visão do futuro",
                "interpretation": "O Dois de Paus representa planejamento, tomar decisões e olhar para possibilidades futuras. Sugere contemplar seu próximo movimento enquanto mantém o que já alcançou."
            },
            "66": {
                "card_name": "Três de Paus",
                "primary_meaning": "Progresso, expansão, previsão",
                "interpretation": "O Três de Paus representa progresso, expansão e olhar à frente. Sugere que planos iniciais estão avançando e há potencial para crescimento e novas oportunidades no horizonte."
            },
            "67": {
                "card_name": "Quatro de Paus",
                "primary_meaning": "Celebração, harmonia, retorno ao lar",
                "interpretation": "O Quatro de Paus representa celebração, harmonia e conquistas marcantes. Sugere um tempo de alegria, estabilidade e se reunir com outros para celebrar sucesso."
            },
            "68": {
                "card_name": "Cinco de Paus",
                "primary_meaning": "Competição, conflito, desafios",
                "interpretation": "O Cinco de Paus representa competição, conflitos e desafios. Sugere um período de rivalidade ou tensão que pode finalmente levar ao crescimento através de competição saudável."
            },
            "69": {
                "card_name": "Seis de Paus",
                "primary_meaning": "Vitória, reconhecimento, orgulho",
                "interpretation": "O Seis de Paus representa vitória, reconhecimento público e orgulho na realização. Sugere um tempo de triunfo e reconhecimento de seus sucessos por outros."
            },
            "70": {
                "card_name": "Sete de Paus",
                "primary_meaning": "Defesa, perseverança, desafio",
                "interpretation": "O Sete de Paus representa manter sua posição, perseverança e enfrentar desafios. Sugere defender sua posição e manter sua vantagem através da determinação."
            },
            "71": {
                "card_name": "Oito de Paus",
                "primary_meaning": "Ação rápida, movimento, progresso",
                "interpretation": "O Oito de Paus representa ação rápida, movimento e progresso rápido. Sugere eventos se movendo rapidamente e mensagens ou oportunidades chegando de repente."
            },
            "72": {
                "card_name": "Nove de Paus",
                "primary_meaning": "Resiliência, persistência, última resistência",
                "interpretation": "O Nove de Paus representa resiliência, persistência e força defensiva. Sugere manter vigilância e continuar apesar da fadiga ou desafios."
            },
            "73": {
                "card_name": "Dez de Paus",
                "primary_meaning": "Fardo, responsabilidade, trabalho duro",
                "interpretation": "O Dez de Paus representa fardos, responsabilidades e obrigações esmagadoras. Sugere carregar responsabilidades pesadas e a necessidade de gerenciar ou delegar tarefas."
            },
            "74": {
                "card_name": "Valete de Paus",
                "primary_meaning": "Exploração, entusiasmo, descoberta",
                "interpretation": "O Valete de Paus representa exploração, entusiasmo e novas descobertas. Sugere o surgimento de novos interesses, faíscas criativas e mensagens emocionantes."
            },
            "75": {
                "card_name": "Cavaleiro de Paus",
                "primary_meaning": "Ação, aventura, impulsividade",
                "interpretation": "O Cavaleiro de Paus representa ação, aventura e movimento impulsivo. Sugere avançar com energia e paixão, embora às vezes sem planejamento adequado."
            },
            "76": {
                "card_name": "Rainha de Paus",
                "primary_meaning": "Confiança, vitalidade, determinação",
                "interpretation": "A Rainha de Paus representa confiança, vitalidade e ação determinada. Ela sugere liderança através do carisma e a capacidade de inspirar outros através do poder pessoal."
            },
            "77": {
                "card_name": "Rei de Paus",
                "primary_meaning": "Visão, liderança, empreendedorismo",
                "interpretation": "O Rei de Paus representa visão, liderança e espírito empreendedor. Sugere domínio de empreendimentos criativos e a capacidade de inspirar outros em direção a um objetivo."
            }
        }
    },
    "welcomeSpread": {
        "initialMessage": "Respire comigo um instante.\nEm poucas palavras: sobre qual situação você busca clareza hoje?",
        "thankYouMessage": "Obrigado por compartilhar. Estou aqui para ajudá-lo a encontrar clareza.",
        "placeholder": "Digite sua mensagem...",
        "recording": "Gravando..."
    },
    "navigation": {
        "today": "Hoje",
        "journal": "Diário",
        "new": "Novo",
        "readings": "Leituras",
        "feedback": "Feedback",
        "settings": "Configurações"
    },
    "profileOptions": {
        "experienceLevels": {
            "newToTarot": "Novo no tarot",
            "someExperience": "Alguma experiência",
            "experiencedReader": "Leitor experiente"
        },
        "readingFrequencies": {
            "daily": "Diário",
            "weekly": "Semanal",
            "occasionally": "Ocasionalmente"
        },
        "deckPreferences": {
            "riderWaite": "Rider-Waite",
            "celestialMinimalist": "Minimalista Celestial",
            "thoth": "Thoth"
        },
        "userGoals": {
            "loveRelationships": "Amor / Relacionamentos",
            "careerFinances": "Carreira / Finanças",
            "personalGrowth": "Crescimento Pessoal",
            "healthWellbeing": "Saúde / Bem-estar",
            "curiosityExploration": "Curiosidade / Exploração"
        },
        "aiTonePreferences": {
            "directPractical": "Direto e prático",
            "gentleIntuitive": "Gentil e intuitivo",
            "deepSymbolic": "Profundo e simbólico"
        },
        "languages": {
            "english": "Inglês",
            "portuguese": "Português",
            "spanish": "Espanhol",
            "french": "Francês",
            "german": "Alemão"
        }
    },
    "reading": {
        "wasThisHelpful": "Esta leitura foi útil?",
        "helpful": "Útil",
        "notHelpful": "Não útil",
        "helpfulSuccess": "Obrigado pelo seu feedback!",
        "notHelpfulSuccess": "Obrigado pelo seu feedback!",
        "evaluationError": "Falha ao salvar sua avaliação"
    },
    "cardSelection": {
        "title": "Selecione Suas Cartas",
        "cardsSelected": "{{count}} / {{max}} cartas selecionadas",
        "shuffleCards": "Embaralhar Cartas",
        "shuffling": "Embaralhando...",
        "selectionComplete": "Seleção Completa..."
    },
    // Import readingTypes from external file
    readingTypes,
    cardsTranslations: cards.cardsTranslations
};

export default ptBRTranslations; 